import { memo } from 'react';
import { ChangeControlDataForm } from 'cancellations/view-models/cancellation-due-death';
import { FormikErrors, FormikTouched } from 'formik';
import { Grid } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import CancellationReason from './cancellation-reason';

interface ChangeControlDataFormProps {
  changeControlDataForm?: ChangeControlDataForm;
  errors: FormikErrors<ChangeControlDataForm> | undefined;
  touched: FormikTouched<ChangeControlDataForm> | undefined;
  handleFormFieldChange: (
    key: keyof ChangeControlDataForm,
    value: ChangeControlDataForm[keyof ChangeControlDataForm]
  ) => void;
}

const ChangeControlDataFormComponent = ({
  changeControlDataForm,
  errors,
  touched,
  handleFormFieldChange,
}: ChangeControlDataFormProps): React.ReactElement => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data decorrenza"
          aria-label="Data decorrenza"
          value={changeControlDataForm?.effectiveDate || null}
          onChange={(date) => {
            handleFormFieldChange('effectiveDate', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="effectiveDate"
              {...params}
              fullWidth
              error={touched?.effectiveDate && Boolean(errors?.effectiveDate)}
              helperText={errors?.effectiveDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <CancellationReason
          label="Motivo cancellazione"
          value={changeControlDataForm?.cancellationReason || ''}
          error={touched?.cancellationReason && Boolean(errors?.cancellationReason)}
          onChange={(event) => handleFormFieldChange('cancellationReason', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

ChangeControlDataFormComponent.displayName = 'Change control data form component';

const ChangeControlDataFormMemo = memo(ChangeControlDataFormComponent);
export default ChangeControlDataFormMemo;
